import { render, staticRenderFns } from "./UpdateSystemBank.vue?vue&type=template&id=12ffc0ff&scoped=true"
import script from "./UpdateSystemBank.vue?vue&type=script&lang=js"
export * from "./UpdateSystemBank.vue?vue&type=script&lang=js"
import style0 from "./UpdateSystemBank.vue?vue&type=style&index=0&id=12ffc0ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ffc0ff",
  null
  
)

export default component.exports